window.bootstrapAlert = function () {
  let _self = [];
  _self.content = document.getElementsByClassName("alert-content")[0];

  function template(type, text){
    const wrapper = document.createElement('div');
    wrapper.innerHTML= `<div class="alert ${type} alert-dismissible fade show" role="alert">
                ${text}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>`;
    return  wrapper.firstChild;
  }

  function clearMessage(elem, timer = 6000) {
    setInterval(function () {
      elem.remove();
    }, timer);
  }

  _self.addAlert = function (text, timer = 6000) {
    const elem = template('alert-warning', text);
    _self.content.appendChild(elem);
    clearMessage(elem, timer);
  };

  _self.addSuccess = function (text, timer = 6000) {
    const elem = template('alert-success', text);
    _self.content.appendChild(elem);
    clearMessage(elem, timer);
  };
  _self.addError = function (text, timer = 6000) {
    const elem = template('alert-danger', text);
    _self.content.appendChild(elem);
    clearMessage(elem, timer);
  };

  return {
    addAlert: _self.addAlert,
    addSuccess: _self.addSuccess,
    addError: _self.addError,
  };
};
